import {
  defaultFont,
  container,
  containerFluid,
  infoColor,
  whiteColor,
  grayColor
} from "assets/jss/material-dashboard-react.jsx";

const footerStyle = theme => ({
  block: {},
  left: {
    float: "left!important",
    display: "block"
  },
  right: {
    margin: "0",
    fontSize: "14px",
    float: "right!important",
    padding: "15px"
  },
  footer: {
    color:
      theme.palette && theme.palette.type === "dark"
        ? "rgba(240,240,240,0.74)"
        : infoColor[0],
    bottom: "0",
    borderTop:
      theme.palette && theme.palette.type === "dark"
        ? "1px solid rgba(240,240,240,0.12)"
        : "1px solid " + grayColor[15],
    padding: "0",
    ...defaultFont,
    zIndex: 4
  },
  container: {
    zIndex: 3,
    ...container,
    position: "relative"
  },
  containerFluid: {
    zIndex: 3,
    ...containerFluid,
    position: "relative"
  },
  a: {
    color: infoColor[0],
    textDecoration: "none",
    backgroundColor: "transparent"
  },
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0",
    width: "auto"
  },
  whiteColor: {
    "&,&:hover,&:focus": {
      color: whiteColor
    }
  }
});
export default footerStyle;
